import { cn } from '@eliadmin/core/src/utils/style-utils';

export function GallerySkeletonCard() {
  return (
    <div
      className={cn(
        'animate-pulse',
        'relative flex h-[205px] w-full items-end justify-center overflow-hidden rounded-[16px] bg-white pb-8 sm:h-[232px]',
      )}
    >
      <div className="relative z-10 h-6 w-[65%] rounded-[12px] bg-slate-50" />
    </div>
  );
}
